const checkRegistrations = async () => {
    let registrations = await navigator.serviceWorker.getRegistrations()
    console.log('checkRegistrations', registrations)
}

const registerServiceWorker = async () => {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        try {
            const registration = await navigator.serviceWorker.register(
                `${process.env.BASE_URL}service-worker.js`
            )

            if (registration.installing) {
                console.log('RegisterServiceWorker: installing')
            } else if (registration.waiting) {
                console.log('RegisterServiceWorker: installed')
            } else if (registration.active) {
                console.log('RegisterServiceWorker: active')
            }
        } catch (error) {
            console.error(`RegisterServiceWorker: Registration failed with ${error}`)
        }

        checkRegistrations()
    }
}

// let refreshing
// navigator.serviceWorker.addEventListener('controllerchange', function () {
//     if (refreshing) return
//     window.location.reload()
//     console.log('Service worker: Controllerchange window reloaded after update')
//     refreshing = true
// })

registerServiceWorker()
